<template>
  <div class="page-header">
    <div class="page-header_left">
      {{ title }}  
    </div>
    <div class="page-header_right" v-if="showRightText">
      Fields marked with a
      <span class="page-header_right__mark">red asterisk *</span>
      are required.
    </div>
  </div>
</template>

<script>
/**
 * 页头
 */
export default {
  name: "enterpriseNetworkPageHeader",
  props: {
    title: {
      type: String,
      required: true
    },
    // 是否显示右侧的提示文字
    showRightText: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.page-header {
  height: 60px;
  display: flex;
  padding-left: 20px;
  column-gap: 18px;
  line-height: 150%;
  align-items: center;
  border-bottom: 1px solid #e5e5e5;
}
.page-header_left {
  font-size: 18px;
  font-weight: bold;
  color: #505050;
}
.page-header_right {
  font-size: 16px;
  color: #808080;
}
.page-header_right__mark {
  color: #d8002f;
}
</style>



// WEBPACK FOOTER //
// src/views/channelAgreement/twentyTwentyFive/EBG/components/pageHeader.vue